import axios from "axios";
import {
  CLIENT_LIST_REQUEST,
  CLIENT_LIST_SUCCESS,
  CLIENT_LIST_FAIL,
  CLIENT_SINGLE_REQUEST,
  CLIENT_SINGLE_SUCCESS,
  CLIENT_SINGLE_FAIL,
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAIL,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_FAIL,
  ACTIVATE_DEACTIVATE_CLIENT_REQUEST,
  ACTIVATE_DEACTIVATE_CLIENT_SUCCESS,
  ACTIVATE_DEACTIVATE_CLIENT_FAIL,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAIL,
} from "constants/clientConstants";
import { REACT_APP_API_URL } from "constants/apiConstants";
import ClientsService from "services/clients-service";

export const getClientList = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLIENT_LIST_REQUEST,
    });

    const res = await ClientsService.getClients();

    dispatch({
      type: CLIENT_LIST_SUCCESS,
      payload: res.foundClients,
    });
  } catch (error) {
    console.log(
      "🚀 ~ file: clientsTableData.js:51 ~ getClientList ~ error:",
      error
    );
    dispatch({
      type: CLIENT_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const getClientSingle = (clientId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CLIENT_SINGLE_REQUEST,
    });

    const res = await ClientsService.getSingleClient(clientId);
    console.log("🚀 ~ file: clientActions.js:56 ~ getClientSingle ~ res:", res);

    dispatch({
      type: CLIENT_SINGLE_SUCCESS,
      payload: res.foundClient,
    });
  } catch (error) {
    dispatch({
      type: CLIENT_SINGLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const clientCreate = (client) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CREATE_CLIENT_REQUEST,
    });

    const res = await ClientsService.createClient(client);
    console.log("🚀 ~ file: clientActions.js:80 ~ clientCreate ~ res:", res);
    dispatch(getClientList());

    dispatch({
      type: CREATE_CLIENT_SUCCESS,
      payload: res,
    });
  } catch (error) {
    dispatch({
      type: CREATE_CLIENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};

export const clientUpdating =
  (clientId, client) => async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_CLIENT_REQUEST,
      });

      const res = await ClientsService.updateClient(clientId, client);
      console.log("🚀 ~ file: clientActions.js:106 ~ res:", res);
      dispatch(getClientSingle(clientId));
      dispatch(getClientList());

      dispatch({
        type: UPDATE_CLIENT_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log("🚀 ~ file: clientActions.js:115 ~ error:", error);
      dispatch({
        type: UPDATE_CLIENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const activateDeactivateClient =
  (clientId, client) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ACTIVATE_DEACTIVATE_CLIENT_REQUEST,
      });

      const res = await ClientsService.activateDeactivateDashClient(
        clientId,
        client
      );
      console.log("🚀 ~ file: clientActions.js:137 ~ res:", res);
      dispatch(getClientSingle(clientId));
      dispatch(getClientList());

      dispatch({
        type: ACTIVATE_DEACTIVATE_CLIENT_SUCCESS,
        payload: res,
      });
    } catch (error) {
      console.log("🚀 ~ file: clientActions.js:115 ~ error:", error);
      dispatch({
        type: ACTIVATE_DEACTIVATE_CLIENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error,
      });
    }
  };

export const clientDelete = (clientId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DELETE_CLIENT_REQUEST,
    });

    const res = await axios.put(
      `${REACT_APP_API_URL}/admin/clients/client/${clientId}`
    );

    dispatch({
      type: DELETE_CLIENT_SUCCESS,
      payload: res,
    });
  } catch (error) {
    dispatch({
      type: DELETE_CLIENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error,
    });
  }
};
